import React from 'react';
export function Hero() {
  return <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden" aria-label="Hero section" data-id="element-143">
      {/* Background Image */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url('https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=1600&q=80')"
    }} aria-hidden="true" data-id="element-144" />

      {/* Dark Overlay */}
      <div className="absolute inset-0" style={{
      background: 'rgba(0,0,0,0.62)'
    }} aria-hidden="true" data-id="element-145" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center text-white py-32" data-id="element-146">
        <p className="animate-fade-in-up text-sm font-semibold tracking-widest uppercase mb-6 text-[#3A9A6A]" data-id="element-147">
          Rodriguez Rangel Consulting LLC
        </p>

        <h1 className="animate-fade-in-up-delay-1 text-5xl md:text-7xl font-extrabold leading-tight mb-6 tracking-tight" data-id="element-148">
          RR Group Consulting
        </h1>

        <p className="animate-fade-in-up-delay-2 text-xl md:text-2xl font-medium mb-6 text-white/80" data-id="element-149">
          Business &amp; Technology Consulting Firm
        </p>

        <p className="animate-fade-in-up-delay-2 text-lg text-white/70 max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-150">
          We provide professional business consulting and technology consulting
          services to entrepreneurs and companies across the United States and
          Latin America.
        </p>

        <div className="animate-fade-in-up-delay-3" data-id="element-151">
          <a href="#contact" className="inline-block bg-[#3A9A6A] hover:bg-[#2d7a54] text-white font-semibold rounded-lg px-8 py-4 text-lg transition-colors duration-200 shadow-lg" data-id="element-152">
            Request Consultation
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce" aria-hidden="true" data-id="element-153">
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex items-start justify-center pt-2" data-id="element-154">
          <div className="w-1 h-2 bg-white/60 rounded-full" data-id="element-155" />
        </div>
      </div>
    </section>;
}